//
import moment from 'moment'

//
export default [
    {
        text    : 'n°',
        value   : 'invoice_number',
    },
    {
        text    : 'rut',
        format  : 'rut',
        value   : ({ pch_provider }) => pch_provider.rut,
    },
    {
        text    : 'proveedor',
        value   : ({ pch_provider }) => pch_provider.business_name,
    },
    {
        text    : 'fecha de emisión',
        align   : 'center',
        format  : 'date',
        value   : 'emission_date',
    },
    {
        text    : 'neto',
        align   : 'center',
        format  : 'currency',
        value   : 'new_subtotal',
    },
    {
        text    : 'iva',
        align   : 'center',
        format  : 'currency',
        value   : 'iva',
    },
    {
        text    : 'total',
        align   : 'center',
        format  : 'currency',
        value   : 'total',
    },
    {
        text    : 'Condición de pago', 
        align   : 'center',
        value   : ({ pch_payment_condition }) => pch_payment_condition.type,
    }
]
